import { render, staticRenderFns } from "./select-place-to-pay-documents-type.vue?vue&type=template&id=1c2bf688"
import script from "./select-place-to-pay-documents-type.vue?vue&type=script&lang=js"
export * from "./select-place-to-pay-documents-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports